import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  GrantTerm,
  GrantedArea,
  KSANCardNumberIssued,
  NameLowercase,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityCardsToExternalEntitiesRenewTemplate = {
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  unit: string;
  KSANCardNumberIssued: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityCardsToExternalEntitiesRenewTemplate: TemplatesValue<SecurityCardsToExternalEntitiesRenewTemplate> =
  {
    fileName: "DanhSachNhanVienCapLaiThe",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      NameLowercase,
      Sex,
      PersonalId,
      Regency,
      {
        ...Team,
        header: "Đơn vị",
      },
      KSANCardNumberIssued,
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: [
      "name",
      "sex",
      "personalId",
      "regency",
      "unit",
      "KSANCardNumberIssued",
      "grantTerm",
      "grantedArea",
      "note",
    ],
  };
